import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    heading: 'Confirm with your passcode',
  },
  fr: {
    heading: 'Confirmez avec votre code secret',
  },
} as const);

export default locales;
